import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ScheduleCrmTaskModel } from 'src/app/models/schedule-cmr-task.model';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-schedule-tasks-crm-list',
    templateUrl: './schedule-tasks-crm-list.component.html',
    styleUrls: ['./schedule-tasks-crm-list.component.scss'],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatButton, DatePipe, PageHeaderComponent, EmptyStateComponent]
})
export class ScheduleTasksCRMListComponent implements OnInit {
  private readonly workTaskSrv = inject(WorkTaskService);
  private readonly router = inject(Router);


  selectedId: string = '';
  crmTaskList: ScheduleCrmTaskModel[] = [];
  /** True after the first response arrives; avoids showing the empty state while loading. */
  loaded = false;

  ngOnInit(): void {
    this.getCrmList();
  }

  getCrmList() {
    this.workTaskSrv.getCrmTaskReportList().subscribe((data: ScheduleCrmTaskModel[]) => {
      this.crmTaskList = this.sortData(data);
      this.loaded = true;
    })
  }

  /** Newest first. creationDate arrives as an ISO string, so it is parsed before comparing. */
  sortData(data: ScheduleCrmTaskModel[]) {
    const time = (task: ScheduleCrmTaskModel) => new Date(task.creationDate).getTime() || 0;
    return data.sort((a, b) => time(b) - time(a));
  }

  goToWorkloadStepTwo(opportunityId: number) {
    this.router.navigate(['/workload'], { queryParams: { opportunityId: opportunityId } });
  }

  // expandDetail(id: string) {
  //   this.selectedId = this.selectedId == id ? '' : id;
  // }

}
